import axios from './axios';

export const serviceTypesAPI = {
  getAll: async (params) => {
    const response = await axios.get('/service-types', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`/service-types/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post('/service-types', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`/service-types/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`/service-types/${id}`);
    return response.data;
  },
};
